import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FieldSet, flattenObj, OfbizField, OfbizForm, OfbizFormField, OfbizFormsService } from '@urbannex/ofbiz-forms';
import { CustomContainerInterFace } from '../../custom-container/custom-container-interface';

@Component({
  selector: 'ubs-view-blog-container',
  templateUrl: './view-blog-container.component.html',
  styleUrls: ['./view-blog-container.component.scss']
})
export class ViewBlogContainerComponent implements OnInit,CustomContainerInterFace {
  @Input() selectedValue:any;
  @Input() ofbizForm:OfbizForm;
  tempForm = this.fb.group({});
  data:any;
  fields:OfbizField[];
  responseMessage:string;
  contentName:string;
  contentId:string;
  statusId:string;
  description:string;
  articleData:string;
  summaryData:string;
  imageContentId:string;
  imageUrl:string;
  baseUrl:string = this.ofbizFormsService.getBaseUrl()
  editArticleForm:FormGroup;
  target:string;
  isMultiPart:boolean;// = this.ofbizForm.isMultiPart()


  constructor(private fb:FormBuilder,private ofbizFormsService:OfbizFormsService) {
    this.editArticleForm = this.fb.group({
      contentId:[],
      blogContentId:[],
      statusInfo:this.fb.group({
        statusId:[],
      }),
      descriptionInfo:this.fb.group({
        description:[],
      }),
      contentNameInfo:this.fb.group({
        contentName:[],
      }),
      summaryInfo:this.fb.group({
        summaryContentId:[],
        summaryData:[],
      }),      
      articleInfo:this.fb.group({
        articleContentId:[],
        articleData:[],
      }),
      uploadInfo:this.fb.group({
        imageContentId:[],
        uploadedFile:[]
      })      
    });
    console.log({Controls:this.editArticleForm.controls});
   }

  fieldSets: FieldSet[];

  ngOnInit(): void {
    console.log({dataFromInterFace:this.data});
    this.ofbizForm = this.data.form;
    this.fields = this.ofbizForm.fields;
    if(this.data.action == "edit"){
      this.selectedValue = this.data.selectedValue;
      this.getValue(this.selectedValue);
      this.target = this.resolveTarget(this.selectedValue.event,this.data.form.target,this.data.form.altTargets);
    }else if(this.data.action == "add"){
      //this.ofbizForm = this.data.form;
      this.target = this.ofbizForm.target;
      this.populateForm(this.data.parameters);
      this.responseMessage = "success";
      //console.log({data:this.data,parameters:this.data.parameters});
    }
    
    //console.log({"selectedValueVieBlog":this.selectedValue});
    
    
    this.isMultiPart = this.data.form.isMultiPart(this.data.form.getFields());
    console.log({target:this.target});
    console.log({isMultiPart:this.isMultiPart});
  }
  /**
   * Funtion to set fields of the blog entry
   * @param data  - contentId, blogContentId,statusId,articleContentId, summaryContentId,imageContentId
   */
  populateForm(data){
    //console.log(data);
    if(data["contentId"]){
      this.editArticleForm.controls["contentId"].patchValue(data["contentId"]);
    }
    if(data["blogContentId"]){
      this.editArticleForm.controls["blogContentId"].patchValue(data["blogContentId"]);
    }
    if(data["statusId"]){
      (<FormGroup>this.editArticleForm.controls["statusInfo"]).controls["statusId"].patchValue(data["statusId"]);
    }
    if(data["articleContentId"]){
      (<FormGroup>this.editArticleForm.controls["articleInfo"]).controls["articleContentId"].patchValue(data["articleContentId"]);
    }
    if(data["summaryContentId"]){
      (<FormGroup>this.editArticleForm.controls["summaryInfo"]).controls["summaryContentId"].patchValue(data["summaryContentId"]);
    }
    if(data["imageContentId"]){
      (<FormGroup>this.editArticleForm.controls["uploadInfo"]).controls["imageContentId"].setValue(data["imageContentId"]);
    }
  }

  getValue(selectedValue:any):void{
    let formData = selectedValue.data.formData;
    let endPoint = selectedValue.data.endPoint;
    let paramaters = selectedValue.data.parameters;
    if(paramaters != undefined){
      Object.keys(paramaters).forEach(key =>{
        this.tempForm.addControl(key,new FormControl(paramaters[key]));
      });
    }
    //console.log({ofbizForm:this.ofbizForm});
    this.ofbizFormsService.getValue(formData,this.tempForm.value,endPoint)
    .subscribe(responseData => {
      const statusCode = responseData["statusCode"];
      switch (statusCode) {
        case 200:
          if(responseData["successMessage"] == "OK"){
            const data = responseData["data"];
            const formData = data["formData"];
            if(data["responseMessage"] == "success"){
              this.responseMessage = "success";
              let fields:any[] = formData["fields"];
              fields.forEach(field => {
                //console.log({field:field});
                let fieldName = Object.keys(field)[0];
                let value = String(Object.values(field)[0]);
                //console.log({fieldName:fieldName,value:value});
                switch(fieldName){
                  case "contentId":
                    this.contentId = value;
                    this.editArticleForm.controls["contentId"].patchValue(value);
                    break;
                  case "blogContentId":
                    this.editArticleForm.controls["blogContentId"].patchValue(value);
                    break;
                  case "contentName":
                    this.contentName = value;
                    (<FormGroup>this.editArticleForm.controls["contentNameInfo"]).controls["contentName"].setValue(value);
                    break
                  case "summaryData":
                    this.summaryData = value;
                    (<FormGroup>this.editArticleForm.controls["summaryInfo"]).controls["summaryData"].setValue(value);
                    break
                  case "articleData":
                    this.articleData = value;
                    (<FormGroup>this.editArticleForm.controls["articleInfo"]).controls["articleData"].setValue(value);
                    break;
                  case "description":
                    this.description = value;
                    (<FormGroup>this.editArticleForm.controls["descriptionInfo"]).controls["description"].patchValue(value);
                    break;
                  case "imageContentId":
                    this.imageUrl = this.baseUrl+"images/"+value;
                    break;
                  case "statusId":
                    this.statusId = value;
                    (<FormGroup>this.editArticleForm.controls["statusInfo"]).controls["statusId"].patchValue(value);
                }
              })
              /* this.contentName = data.contentName;
              this.summaryData = data.summaryData;
              this.articleData = data.articleData; */
              /* if(data.imageContentId){
                this.imageUrl = this.baseUrl+"images/"+data.imageContentId;
              } */
              if(data.description){
                this.description = data.description;
              }
              if(data.statusId){
                this.statusId = data.statusId;
              }
              //console.log(this.imageUrl);
              this.populateForm(data);
            }
          }
          break;
        case 404:
        
          break;
        case 500:
        
          break;
        default:
          break;
      }
    })
  }

  onSubmit(){
    console.log(JSON.stringify(this.editArticleForm.value));
    let flattened = flattenObj(this.editArticleForm.value);
    console.log(JSON.stringify(flattened));
    
    let formData = new FormData();
    formData.append("contentId",this.editArticleForm.get("contentId").value);
    formData.append("blogContentId",this.editArticleForm.get("blogContentId").value);
    formData.append("articleContentId",this.editArticleForm.get("articleInfo").get("articleContentId").value);
    formData.append("summaryContentId",this.editArticleForm.get("summaryInfo").get("summaryContentId").value);
    formData.append("imageContentId",this.editArticleForm.get("uploadInfo").get("imageContentId").value);
    formData.append("contentName",this.editArticleForm.get("contentNameInfo").get("contentName").value);
    formData.append("description",this.editArticleForm.get("descriptionInfo").get("description").value);
    formData.append("summaryData",this.editArticleForm.get("summaryInfo").get("summaryData").value);
    formData.append("articleData",this.editArticleForm.get("articleInfo").get("articleData").value);
    console.log({uploadedFile:this.editArticleForm.get("uploadInfo").get("uploadedFile").value});
    if(this.editArticleForm.get("uploadInfo").get("uploadedFile").value != null){
      formData.append("uploadedFile",(this.editArticleForm.get("uploadInfo").get("uploadedFile").value));
    }
    
    /* for(var pair of formData.entries()) {
      console.log(pair[0]+ ', '+ pair[1]); 
    } */
    console.log("....... submitting");
    console.log({thisTarget:this.target});
    this.ofbizFormsService.postFormData(formData,"content",this.target,this.isMultiPart).subscribe(data => {
      console.log(data);
    })
    /* this.ofbizFormsService.postFormData(formData,this.target)
    .subscribe(data => {
      console.log(data);
    }) */
  }

  resolveTarget(event:string,target:string,altTargets:any[]):string{
    console.log({resolvingTarget:target});
    let resolvedTarget = target;
    if(event == "edit"){
      let altTarget = altTargets[0];
      resolvedTarget = altTarget["targetExdr"]["original"];
    }
    return resolvedTarget
  }

}
